import type { ScheduleDestinationKind } from "./types";

/** A Slack channel as the owner types it: its id, public (`C…`) or private (`G…`). The app cannot list or name channels. */
export const SLACK_CHANNEL_ID = /^[CG][A-Z0-9]{6,}$/;
/** How many places one schedule's answer may go. */
export const DESTINATIONS_MAX = 20;
/** What the owner may call a channel ("#product"). */
export const CHANNEL_LABEL_MAX = 80;

const KIND_WORDS: Record<ScheduleDestinationKind, string> = { web: "web chat", slack_dm: "Slack DM", slack_channel: "Slack channel" };

/** One destination in words, the same in the run block, the owner's notices and the screens: "Fanis Koutouvelis (Slack DM)", "#product (Slack channel)". */
export function destinationWords(d: { kind: ScheduleDestinationKind; userName?: string | null; channel?: string | null; label?: string | null }): string {
  const who = d.kind === "slack_channel" ? (d.label?.trim() || d.channel || "a channel") : (d.userName || "someone");
  return `${who} (${KIND_WORDS[d.kind]})`;
}
